var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoveDownFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m277.37-120.48-47.07-47.06 85.29-84.81q-115.76 5.52-199.26-73.79t-83.5-196.73q0-118.4 82.93-200.87 82.94-82.48 201.62-82.48h121.19v65.26h-121.2q-91.74 0-155.39 63.26-63.65 63.25-63.65 154.83 0 89.11 65.68 149.16 65.69 60.06 156.01 58.06l-89.72-89.72 46.83-46.83 165.98 165.98zm241.2-33.54V-440h367.65v285.98zm0-365.98v-286.22h367.65V-520zm68.36-68.37h231.16v-149.48H586.93z"
})));
export default SvgMoveDownFill;